import { useState, useCallback } from "react"

export const usePagination = (initialPage = 1, initialPageSize = 10) => {
  const [page, setPage] = useState(initialPage)
  const [pageSize, setPageSize] = useState(initialPageSize)

  const handlePageChange = useCallback((newPage) => {
    setPage(newPage)
  }, [])

  const handlePageSizeChange = useCallback((newSize) => {
    setPageSize(newSize)
    setPage(1)
  }, [])

  const resetPagination = useCallback(() => {
    setPage(1)
  }, [])

  return {
    page,
    pageSize,
    handlePageChange,
    handlePageSizeChange,
    resetPagination,
    setPage,
    setPageSize
  }
}
